import { render, staticRenderFns } from "./modal-historico-cadastro-aluguel.vue?vue&type=template&id=c4fb4470&scoped=true"
import script from "./modal-historico-cadastro-aluguel.ts?vue&type=script&lang=ts&external"
export * from "./modal-historico-cadastro-aluguel.ts?vue&type=script&lang=ts&external"
import style0 from "./modal-historico-situacao.scss?vue&type=style&index=0&id=c4fb4470&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4fb4470",
  null
  
)

export default component.exports